import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { AavoDataGrid } from "src/components/common/dataGrid/AavoDataGrid.tsx";
import { enumColumn, floatColumn, integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { PurchaseOrderLineSourcesDataGridApi } from "src/api/generated/erp/purchase/purchaseOrder/api/purchaseOrderLineSourcesDataGridApi.ts";
import { getPurchaseOrderAggregatedSourceSourceTypeLabels } from "src/api/generated/erp/db/types/enums/purchaseOrderAggregatedSourceSourceType.ts";
import { PurchaseOrderLineAggregatedSourceView } from "../../../../../api/generated/erp/db/types/tables/purchaseOrderLineAggregatedSourceView.ts";
import { OpenProjectInTreeViewButton } from "../../utilComponents/OpenProjectInTreeViewButton.tsx";
import { OpenCustomerOrderButton } from "../../utilComponents/OpenCustomerOrderButton.tsx";
import { OpenProjectActivityButton } from "../../utilComponents/OpenProjectActivityButton.tsx";
import { OpenShopOrderButton } from "../../utilComponents/OpenShopOrderButton.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface PurchaseOrderLineSourcesDataGridProps {
	purchaseOrderLineId: number;
}

export const PurchaseOrderLineSourcesDataGrid = ({ purchaseOrderLineId }: PurchaseOrderLineSourcesDataGridProps) => {
	return (
		<ClientSideDataGridModel
			customFunctionUiActionView={"PURCHASE_ORDER_LINE_SOURCES"}
			fetchData={() =>
				PurchaseOrderLineSourcesDataGridApi.getData({
					purchaseOrderLineId: purchaseOrderLineId,
				})
			}
			initialParams={{}}
			getRows={(response) => response}
			getRowId={(row) => row.purchaseOrderLineAggregatedSourceId}
			gridId={"6A67C6A75E3B4C77"}
			render={({ dataGridProps }) => (
				<AavoDataGrid<PurchaseOrderLineAggregatedSourceView>
					columns={[
						enumColumn({
							field: "sourceType",
							headerName: i18n.t("source"),
							enumLabels: getPurchaseOrderAggregatedSourceSourceTypeLabels(),
							width: 160,
						}),
						integerColumn({
							field: "sourceId",
							headerName: i18n.t("source_id"),
							width: 120,
						}),
						textColumn({
							field: "sourceDescription",
							headerName: i18n.t("description"),
							width: 500,
						}),
						floatColumn({
							field: "orderedQuantityInBaseUnit",
							headerName: i18n.t("ordered_quantity"),
							width: 120,
						}),
						floatColumn({
							field: "receivedQuantityInBaseUnit",
							headerName: i18n.t("received_quantity"),
							width: 120,
						}),
						floatColumn({
							field: "missingQuantityInBaseUnit",
							headerName: i18n.t("missing_quantity"),
							width: 120,
						}),
					]}
					disableMultipleRowSelection
					rowContextMenuComponents={({ row }) => [
						row.customerOrderId != null && (
							<OpenCustomerOrderButton key={"openCustomerOrder"} customerOrderId={row.customerOrderId} />
						),
						row.projectActivityId != null && (
							<OpenProjectActivityButton key={"openActivity"} projectActivityId={row.projectActivityId} />
						),
						row.projectId != null && (
							<OpenProjectInTreeViewButton key={"openProject"} projectId={row.projectId} />
						),
						row.shopOrderId != null && (
							<OpenShopOrderButton key={"openShopOrder"} shopOrderId={row.shopOrderId} />
						),
					]}
					agentContext={{
						key: defineAgentUiContextKey("erp.purchase.purchaseOrderLineSources.grid"),
						data: {
							purchaseOrderLineId: purchaseOrderLineId,
						},
						rowFields: [
							"purchaseOrderLineAggregatedSourceId",
							"purchaseOrderLineId",
							"sourceType",
							"sourceId",
						],
						selectedRowPathSegment: (row) =>
							row.sourceDescription ?? `${i18n.t("source_id")} ${row.sourceId}`,
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
